import { useState } from 'react';
import { useSelector } from 'react-redux';
import { contributorsByIdSelector } from 'state/selectors/contributors';

const useTeamContributors = ({ team }) => {
  const contributorsById = useSelector(contributorsByIdSelector) || {};
  const { contributor_ids = [] } = team;
  const teamContributors = contributor_ids
    .map(id => contributorsById[id])
    .filter(Boolean);
  const [members, setMembers] = useState(teamContributors);

  return {
    members,
    setMembers
  };
};

export default useTeamContributors;
